import { useAtomValue } from 'jotai';
import { useParams } from 'react-router-dom';

import { useGetTelehealthSessionInfo } from '../../hooks';
import { providerIsOnlineAtom } from '../state';
import { ProviderInfoSection } from './ProviderInfoSection';
import type { WrapperPassThroughProps } from './ProviderInfoSection';

export function ProviderInfoSectionWrapper(props: WrapperPassThroughProps) {
  const { providerShortId, patientShortId } = useParams();
  const { data, loading } = useGetTelehealthSessionInfo(providerShortId, patientShortId);
  const providerIsOnline = useAtomValue(providerIsOnlineAtom);
  const provider = data?.telehealthSessionInfo?.provider;

  return <ProviderInfoSection {...props} loading={loading} provider={provider} providerIsOnline={providerIsOnline} />;
}
